import React from "react";
import SocialMediaFaqs from "./SocialMediaFaqs";
import { socialLeftImg } from "../..";

function SocialMediaSection() {
  return (
    <section className="socialMediaSection">
      <div className="container">
        <div className="sectionTitle">
          <h4>Protect Every Digital Interaction</h4>
          <p>
            Your brand’s reputation hinges on trust. Vodote Techa ensures your digital presence across web, mobile, and cloud is always secure, reliable, and resilient.
          </p>
        </div>
        <div className="row justify-content-around align-items-center">
          <div className="col-md-5">
            <div className="socialMediaLeftBox">
              <img
                src={socialLeftImg}
                alt="Protect Every Digital Interaction"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-md-5">
            <SocialMediaFaqs />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMediaSection;
